import type { FC } from 'react'
import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const HEADLINE = `Personalized experiences and data privacy aren’t mutually exclusive.`
const DESCRIPTION = `The evolution of consumer privacy has cleared the way for first-party data, collected about a business’ own interactions with its own customers, to move into the spotlight. Thankfully, in today’s digital world, that’s hardly a scarce resource.`

const PersonalizedExperiences: FC = () => (
  <StyledSectionBase variant="centered">
    <StyledSectionContents>
      <CopyTextBase centered={true}>
        <CopyText.Heading tag="h2" variant="h2">
          {HEADLINE}
        </CopyText.Heading>
        <CopyText.Description tag="p" variant="pLarge">
          {DESCRIPTION}
        </CopyText.Description>
      </CopyTextBase>
    </StyledSectionContents>
  </StyledSectionBase>
)

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 0;
  }
`
const StyledSectionContents = styled(Section.Contents)`
  max-width: 684px;
`

export default PersonalizedExperiences
